import { Children, isValidElement, ReactNode } from "react";
import { EmptyArray } from "../../../utilities/EmptyArray";
import { TabProps, Tab } from "../Tab";

/**
 * Gets the tabs from the specified children.
 * @param children The children to get the tabs from.
 * @returns The array of tabs.
 */
export function getTabs(children: ReactNode | undefined): ReadonlyArray<TabProps> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;
      if (child.type !== Tab) {
        console.log("TabSet ignoring unsupported child component.");
        return null;
      }
      return child.props;
    })?.filter((tab) => !!tab) ?? EmptyArray
  );
}
